import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  constructor() {}

  /**
   * Store data in session storage
   * @param key - The key to store the data under
   * @param data - The data to store
   */
  setSessionData<T>(key: string, data: T): void {
    try {
      const serializedData = JSON.stringify(data);
      sessionStorage.setItem(key, serializedData);
    } catch (error) {
      console.error('Error storing data in session storage:', error);
    }
  }

  /**
   * Retrieve data from session storage
   * @param key - The key to retrieve data from
   * @returns The stored data or null if not found
   */
  getSessionData<T>(key: string): T | null {
    try {
      const data = sessionStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error retrieving data from session storage:', error);
      return null;
    }
  }
}
